import { useState } from 'react'
import { useSelector } from 'store/store'
import { Skeleton } from '@mui/material'
import { zeroPad } from 'commons/utils/number'
import { Icon, SectionCard, Typography } from 'components'
import ModalTracking from 'container/SalesOrder/components/ModalTracking'

import * as S from './styles'
import { theme } from 'styles/theme/hav-theme'

export const TrackingSection = () => {
  const {
    detailedInfo: { Tracking },
    loadingDetailedInfo: loading
  } = useSelector((state) => state.ov)

  const [showTrackingModal, setShowTrackingModal] = useState(false)

  const formatDateTime = (date: string) => {
    const dateObj = new Date(date)
    const day = zeroPad(dateObj.getDate(), 2)
    const month = zeroPad(dateObj.getMonth() + 1, 2)
    const hour = zeroPad(dateObj.getHours(), 2)
    const minutes = zeroPad(dateObj.getMinutes(), 2)
    return `${day}/${month} às ${hour}:${minutes}`
  }

  return (
    <SectionCard
      title="Tracking"
      tooltipText="Nesta seção você pode ver um resumo das movimentações em sua OV, incluindo informações sobre quem realizou cada ação e quando ela ocorreu. Clique no botão 'Ver tudo' para acessar mais detalhes e informações adicionais no histórico completo do tracking."
    >
      <S.Wrapper>
        <S.TrackingInfo>
          <S.TrackingInfoItem>
            <Typography design="hav-default-02-text">Criado por</Typography>
            {loading ? (
              <Skeleton height={42} />
            ) : (
              <Typography>
                {Tracking?.UsuarioCadastro} <br />
                {formatDateTime(Tracking?.DataCadastro)}
              </Typography>
            )}
          </S.TrackingInfoItem>
          <S.TrackingInfoItem>
            <Typography design="hav-default-02-text">Última manutenção</Typography>
            {loading ? (
              <Skeleton height={42} />
            ) : (
              <Typography>
                {Tracking?.UsarioUltimaAlteracao} <br />
                {formatDateTime(Tracking?.DataUltimaAlteracao)}
              </Typography>
            )}
          </S.TrackingInfoItem>
        </S.TrackingInfo>
        <S.Divider />
        <S.ButtonArea>
          <S.TrackingButton onClick={() => setShowTrackingModal(true)}>
            <Icon icon="track" color={theme.colors.primary.main} size="15" />
            <span>Ver tudo</span>
          </S.TrackingButton>
        </S.ButtonArea>
      </S.Wrapper>

      {showTrackingModal && (
        <ModalTracking open={showTrackingModal} setOpen={setShowTrackingModal} />
      )}
    </SectionCard>
  )
}
